import { render, staticRenderFns } from "./Layout1.vue?vue&type=template&id=d2555c6a&scoped=true&"
import script from "./Layout1.vue?vue&type=script&lang=js&"
export * from "./Layout1.vue?vue&type=script&lang=js&"
import style0 from "./Layout1.vue?vue&type=style&index=0&id=d2555c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2555c6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VFlex,VImg,VLayout,VRow,VSelect})
